import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../contexts/auth';
import GiustificativiTable from '../components/giustificativi_table';
import BackButton from '../components/back_button';
import Footer from '../components/footer';
import { PlusIcon } from '@heroicons/react/24/outline';
import { getJustificationCustomCompanyList } from '../services/api_justifications';
import GiustificativiCustomTable from '../components/giustificativi_custom_table';
import AddJustificationForm from '../components/form_add_justification';
import PopoverComponentCustom from '../components/popover_component';

 
  const GiustificativiView = () => {
    const { token } = useContext(AuthContext);
    const [showForm, setShowForm] = useState(false);
    const [showFormEdit, setShowFormEdit] = useState(false);
    const [giustificativi, setGiustificativi] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [giustificativo, setGiustificativo] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(null);
    const [giustificativiCustom, setGiustificativiCustom] = useState([]);

    
    useEffect(() => {
        const fetchJustifications = async () => {
          setIsLoading(true);
          try {
            const justificationData = await getJustificationCustomCompanyList(token);
            setGiustificativiCustom(justificationData);
            
            setIsLoading(false);
          } catch (error) {
            setIsError(error);
            setIsLoading(false);
          }
        };

        fetchJustifications();
      }, [token]);

    const onCreateJustificationCustom = (newJustificationData) => {
        setGiustificativiCustom((prevGiustificativCustom) => [...prevGiustificativCustom, newJustificationData]);        
        setShowForm(false);
    };   

  
    const onDeleteCustomJustification = (deletedJustificationId) => {
        const updatedCustomJustifications = giustificativiCustom.filter(
            (justification) => justification.id !== deletedJustificationId
        );
        setGiustificativiCustom(updatedCustomJustifications);
    };

    const handleUpdateJustification = (justificationId, updatedData) => {
        const updatedIndex = giustificativiCustom.findIndex((giust) => giust.id === justificationId);

        if (updatedIndex !== -1) {
            const updatedCustomJustifications = [...giustificativiCustom];
            updatedCustomJustifications[updatedIndex] = {
                ...updatedCustomJustifications[updatedIndex],
                ...updatedData
            };
            setGiustificativiCustom(updatedCustomJustifications);            
        }
    };

    const handleAddNew = () => {
      setShowForm(true);
      setShowFormEdit(false);
    };
  
    const handleEditFormOpen = (giustificativo) => {
        setShowFormEdit(true);
        setShowForm(false);
        setIsEditMode(true);
        setGiustificativo(giustificativo);
    };
  
    const handleCancel = () => {
      setShowForm(false);
      setShowFormEdit(false);
    };

    if(isLoading)
        return <div className="relative block w-full rounded-lg  p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2">
            <div role="status">
                <svg className="inline w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-grey-100 fill-indigo-400" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                </svg>
                <span className="sr-only">Loading...</span>
            </div>
            <span className="mt-2 block text-sm font-semibold text-gray-900">Caricamento...</span>
        </div>
    if (isError) return <div>Error loading data</div>;

    return (
        <div className="min-h-full">
            <PopoverComponentCustom title="Seleziona Giustificativi" />
            <main className="mt-10 pb-8">
                <div className='flex justify-end my-4 mr-10 pr-8'>
                    <BackButton prevLocation="/settings_ratei" />
                    <button
                    className="border flex items-center rounded-md bg-grey-400 px-3 py-2 text-center text-sm bg-indigo-600 text-white font-semibold text-gray-900 shadow-sm hover:bg-indigo-400 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
                    onClick={handleAddNew}
                    >
                    <PlusIcon className="w-4 h-4 mr-1" />
                    Crea Nuovo
                    </button>
                </div>

                {showForm && (
                    <div className="rounded border border-grey-400 p-4 my-8 mx-16">
                        <h1 className="text-sm font-semibold leading-6 text-gray-900">CREA NUOVO GIUSTIFICATIVO</h1>
                        <div>
                            <AddJustificationForm
                                onCancel={handleCancel}
                                onCreateJustificationCustom={onCreateJustificationCustom}

                            />
                        </div>
                    </div>
                )}
                <div className='grid grid-cols-1'>
                    <div className="md:px-8 px-0">
                        <GiustificativiTable />
                    </div>
                </div>
                <div className='grid grid-cols-1'>
                    <div className="md:px-8 px-0">
                        <h1 className='text-sm flex justify-center mt-8 font-semibold leading-6 text-gray-900 uppercase'>Giustificativi personalizzati</h1>
                        <div>
                            <GiustificativiCustomTable 
                                giustificativi={giustificativiCustom} 
                                onEditFormOpen={handleEditFormOpen}
                                onDeleteCustomJustification={onDeleteCustomJustification}
                                onUpdateJustification={handleUpdateJustification}
                            />
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GiustificativiView;
